// App

// Actions
import { useAppSelector } from '../flux/configureStore';

// Constellation
import { Heading, Text, TextButton } from '@zillow/constellation';

// Misc / utils
import * as S from './styles';
import { augmentError, formatForLog } from '../utils/errors';
import { logger } from '../index';

type NoResultsPropType = {
  hasActiveFilters: boolean;
};
const NoResults = ({ hasActiveFilters }: NoResultsPropType) => {
  const setFilter = useAppSelector((state) => state.setFilter);
  const handleResetFilters = async () => {
    try {
      await setFilter();
    } catch (err: any) {
      augmentError(err, {
        root: 'components/CompsCarousel/NoResults#handleResetFilters',
      });

      logger.error(formatForLog(err), 'Filter: Error resetting filters');
    }
  };

  /**
   * Once we know if filters are active or not, we can either render
   * "Remove all filters" or "Try another address"
   */

  return (
    <S.NoResultsContainer>
      <Heading level="6" marginTop="xs" marginBottom="sm">
        We were unable to find any comparable listings
      </Heading>
      {hasActiveFilters && (
        <>
          <Text fontType="body" marginBottom="sm">
            Edit or remove your filters for best results.
          </Text>
          {/* @ts-ignore fontColor="brand" */}
          <TextButton fontColor="brand" onClick={handleResetFilters}>
            Remove all filters
          </TextButton>
        </>
      )}
    </S.NoResultsContainer>
  );
};

export default NoResults;
